import { render, staticRenderFns } from "./ContestList.vue?vue&type=template&id=3c892d02&scoped=true&"
import script from "./ContestList.vue?vue&type=script&lang=js&"
export * from "./ContestList.vue?vue&type=script&lang=js&"
import style0 from "./ContestList.vue?vue&type=style&index=0&id=3c892d02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c892d02",
  null
  
)

export default component.exports